const { Component, render, findDOMNode, Fragment } = wp.element;

const alias = 'PostBerg-';

import axios from 'axios';
//import OwlCarousel2 from 'react-owl-carousel2'
import OwlCarousel2 from './owlcarousel/lib/OwlCarousel.js';
class PostBerg_PostItems extends Component {
  constructor(props) {
    super(props);

    this.state = {
      items: [],
      category: [],
      baseUrl: PostBerg.json_api_url,
      paged: 1,
      windowWidthSize: '',
      show_options: {
        title: false,
        content: false,
        button: false,
        paginate: false,
        category: false
      }
    };

  }

  componentDidMount() {
    this.getPosts();
    this.getCategory();
    this.windowResize();
  }

  getPosts() {
    const { items } = this.state;
    //console.log( items );
    axios.get( `${this.state.baseUrl}posts?per_page=100&_embed` )
    .then(res => {
      res.data.map( (key) => {

        let items = res.data;
        this.setState({ items });

      })
    })
  }

  getCategory() {

    axios.get( `${this.state.baseUrl}categories` )
    .then(res => {
      res.data.map( (key) => {
        let category = res.data;
        this.setState({ category });

      })
    })
  }

  orderBy(order_type) {
    const { items, category } = this.state;
    if(order_type == 'Newest to Oldest') {
      items.sort((a,b) => {
        return new Date(b.date_gmt) - new Date(a.date_gmt);
      });
    }

    if(order_type == 'Oldest to Newest') {
      items.sort((a,b) => {
        return new Date(a.date_gmt) - new Date(b.date_gmt);
      });
    }
    if(order_type == 'A → Z') {
      items.sort((a,b) => {
        if ( a.title.rendered < b.title.rendered ){
          return -1;
        }

        if ( a.title.rendered > b.title.rendered ){
          return 1;
        }

        return 0;
      });
    }

    if(order_type == 'Z → A') {
      items.sort((a,b) => {
        if ( b.title.rendered < a.title.rendered ){
          return -1;
        }

        if ( b.title.rendered > a.title.rendered ){
          return 1;
        }

        return 0;
      });
    }

  }

  buildPostsForSlider() {
    const { items, category } = this.state;

    this.orderBy(this.props.options.orderBy);

    return items.map( (item, index) => {
      let finalDate = new Date( item.date_gmt);
      let monthDate = finalDate.getMonth();
      let yearDate = finalDate.getFullYear();
      let dayDate = finalDate.getDate();
      let monthName = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

      return (
        <div
          className={ `${alias}item show-type-${this.props.options.displayType}` }
        >

          <div className={`${alias}image`}>
            {this.props.options.displayType == 'slider' ? <div className={`${alias}overlay`}></div> : ""}
            <a href={ item.link }>
                { item._embedded['wp:featuredmedia'] ?
                <span style={{
                  height: `${this.props.options.image_height}px`,
                  backgroundImage: `url(${ item._embedded['wp:featuredmedia']['0'].source_url })`
                }}></span>
              : <span style={{
                height: `${this.props.options.image_height}px`,
                backgroundImage: `url(${PostBerg.assets_url}/postberg_placeholder.png)`
              }}></span>
              }

            </a>
          </div>


          <div className={`${alias}content`}>

           <span
              class="dashicons dashicons-edit"
              onClick={() => {
                let show_options = {
                  title: false,
                  content: false,
                  button: false,
                  paginate: false,
                  category: true
                }
                this.setState({ show_options });

                setTimeout(() => {
                  this.sendShowOptions();
                }, 100);

              }}
            ></span>

            {category.map((categ, index)=>{
              return item.categories.map((current_categ) => current_categ == categ.id ? <p
                className={`${alias}category`}
                style={{
                  color: this.props.options.category_text_color,
                  backgroundColor: this.props.options.category_background_color,
                  fontFamily: this.props.options.text_font,
                  fontSize: `${this.props.options.category_text_size}px`,
                  fontWeight: `${this.props.options.category_text_weight}`,
                }}
                >{ categ.name }</p> : "" )
            })}



            { this.props.options.displayDate ? <p className={`${alias}date-span`}>
              <span style={{ marginRight: '10px' }}>{ `${ monthName[monthDate] } ${dayDate }, ${yearDate}`  }</span>
              { item._embedded.replies? <span>{ `${item._embedded.replies[0].length} Comments`  }</span> : <span>0 Comments</span> }
            </p> : "" }

            <h2 style={{
              color: this.props.options.text_color,
              fontFamily: this.props.options.text_font,
              fontSize: `${this.props.options.text_size}px`,
              fontWeight: `${this.props.options.text_weight}`,
              lineHeight: `${this.props.options.text_size}px`
            }}>
            <span
              class="dashicons dashicons-edit"
              onClick={() => {
                let show_options = {
                  title: true,
                  content: false,
                  button: false,
                  paginate: false,
                  category: false
                }
                this.setState({ show_options });

                setTimeout(() => {
                  this.sendShowOptions();
                }, 100);

              }}
            ></span>
              { item.title.rendered }

            </h2>

          </div>

        </div>
      )
    });


  }
  buildPosts(type) {
    const { items, category, paged } = this.state;
    let paginatedItems = {};

    const { text_color, image_height } = this.props.options;

    this.orderBy(this.props.options.orderBy);
    if(type == 'items') {
      paginatedItems = this.paginateItems(items, paged, this.props.options.number_of_items);
    } else if(type == 'carouselItems') {
      paginatedItems.data = items;
    }

    if (!paginatedItems.data) return null;


    return paginatedItems.data.map( (item, index) => {

      // Remove the p tag from content
      let newContent = item.content.rendered.replace(/(<([^>]+)>)/ig,"");

      let finalDate = new Date( item.date_gmt);
      let monthDate = finalDate.getMonth();
      let yearDate = finalDate.getFullYear();
      let dayDate = finalDate.getDate();
      let monthName = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

      return (
        <div
          className={ `${alias}item show-type-${this.props.options.displayType}` }
        >
          <div className={`${alias}image`}>
            {this.props.options.displayType == 'slider' ? <div className={`${alias}overlay`}></div> : ""}
            <a href={ item.link }>
                { item._embedded['wp:featuredmedia'] ?
                <span style={{
                  height: `${image_height}px`,
                  backgroundImage: `url(${ item._embedded['wp:featuredmedia']['0'].source_url })`
                }}></span>
              : <span style={{
                height: `${image_height}px`,
                backgroundImage: `url(${PostBerg.assets_url}/postberg_placeholder.png)`
              }}></span>
              }

            </a>
          </div>

          <div className={`${alias}content`}>
            <h2 style={{
              color: text_color,
              fontFamily: this.props.options.text_font,
              fontSize: `${this.props.options.text_size}px`,
              fontWeight: `${this.props.options.text_weight}`,
              lineHeight: `${this.props.options.text_size}px`
            }}>

              <span
                class="dashicons dashicons-edit"
                onClick={() => {
                  let show_options = {
                    title: true,
                    content: false,
                    button: false,
                    paginate: false,
                    category: false
                  }
                  this.setState({ show_options });

                  setTimeout(() => {
                    this.sendShowOptions();
                  }, 100);

                }}
              ></span>
              <a style={{
                color: text_color,
                fontFamily: this.props.options.text_font,
                fontSize: `${this.props.options.text_size}px`,
                fontWeight: `${this.props.options.text_weight}`,
                lineHeight: `${this.props.options.text_size}px`
              }} href={ item.link }>{ item.title.rendered }</a>
            </h2>

            { this.props.options.displayDate ? <p className={`${alias}date-span`}>
              <span style={{ marginRight: '10px' }}>{ `${ monthName[monthDate] } ${dayDate }, ${yearDate}`  }</span>
              { item._embedded.replies? <span>{ `${item._embedded.replies[0].length} Comments`  }</span> : <span>0 Comments</span> }
            </p> : "" }



            <p className={`${alias}content-pa`} style={{
              color: this.props.options.main_text_color,
              fontFamily: this.props.options.main_text_font,
              fontSize: `${this.props.options.main_text_size}px`,
              fontWeight: `${this.props.options.main_text_weight}`
            }}
            >
            <span
                class="dashicons dashicons-edit"
                onClick={() => {
                  let show_options = {
                    title: false,
                    content: true,
                    button: false,
                    paginate: false,
                    category: false
                  }
                  this.setState({ show_options });

                  setTimeout(() => {
                    this.sendShowOptions();
                  }, 100);

                }}
              ></span>
              { newContent }

            </p>

            <span
              class="dashicons categ dashicons-edit"
              onClick={() => {
                let show_options = {
                  title: false,
                  content: false,
                  button: false,
                  paginate: false,
                  category: true
                }
                this.setState({ show_options });

                setTimeout(() => {
                  this.sendShowOptions();
                }, 100);

              }}
            ></span>
            {category.map((categ, index)=>{
              return item.categories.map((current_categ) => current_categ == categ.id ? <p
                  className={`${alias}category`}
                  style={{
                    color: this.props.options.category_text_color,
                    backgroundColor: this.props.options.category_background_color,
                    fontFamily: this.props.options.text_font,
                    fontSize: `${this.props.options.category_text_size}px`,
                    fontWeight: `${this.props.options.category_text_weight}`,
                  }}
                >{ categ.name }</p> : "" )
            })}

            </div>

             { !this.props.options.hideReadMore ? <div className={`${alias}btnreadmore`}>


            <a
              href={ item.link }
              className={`${alias}read-more`}
              style={{
                borderRadius: this.props.options.buttonRadius ? "30px" : "0",
                borderColor: this.props.options.button_border_color,
                color: this.props.options.button_color,
                fontFamily: this.props.options.button_text_font,
                fontSize: `${this.props.options.button_text_size}px`,
                fontWeight: `${this.props.options.button_text_weight}`,
                backgroundColor: this.props.options.button_bg_color
              }}
            > Read More </a>

            <span
              class="dashicons dashicons-edit"
              onClick={() => {
                let show_options = {
                  title: false,
                  content: false,
                  button: true,
                  paginate: false,
                  category: false
                }
                this.setState({ show_options });

                setTimeout(() => {
                  this.sendShowOptions();
                }, 100);

              }}
            ></span>

            </div> : "" }
        </div>
      )
    })
  }




  paginateItems(items, page, per_page) {
    let offset = (page - 1) * per_page;
    let paginatedItems = items.slice(offset).slice(0, per_page);
    let total_pages = Math.ceil(items.length / per_page);

    return {
      page: page,
      total: items.length,
      data: paginatedItems
    };
  }

  pagination() {
    const delta = 3;
    const { paged, items } = this.state;
    let paginatedItems = this.paginateItems(items, paged, this.props.options.number_of_items);

    const lastPage = Math.ceil( paginatedItems.total / this.props.options.number_of_items );
    const range = [];

    for (let i = Math.max(2, (paged - delta)); i <= Math.min((lastPage - 1), (paged + delta)); i += 1) {
       range.push(i);
    }

    if ((paged - delta) > 2) {
       range.unshift('...');
    }
    if ((paged + delta) < (lastPage - 1)) {
       range.push('...');
    }

    let dots_key = 0;

    range.unshift(1);
    if (lastPage !== 1) range.push(lastPage);

    if( range.length == 1 ) return null;
    const pagin = range.map((key, index) => {
    if ( !isNaN(key) ) {
      return <a
        key={ key }
        style={{
          color: this.props.options.paginate_text_color,
          backgroundColor: paged == key ? this.props.options.paginate_active_color : this.props.options.paginate_background_color,
          fontFamily: this.props.options.text_font,
          fontSize: `${this.props.options.paginate_text_size}px`,
          fontWeight: `${this.props.options.paginate_text_weight}`

        }}
        className={ paged == key ? '__is_selected' : '' }
        href= {`#${ key }`}
        onClick= { (e) => {
          e.preventDefault();
          this.setState({ paged: key })
        }}> { key} </a>
    } else {
      return <span className="dots-span" key={ --dots_key }>{key}</span>
    }

    });

    return <div className={`${alias}PostItems-pagination`}>
        { pagin }
        <span
          class="dashicons dashicons-edit"
          onClick={() => {
            let show_options = {
              title: false,
              content: false,
              button: false,
              paginate: true,
              category: false
            }
            this.setState({ show_options });

            setTimeout(() => {
              this.sendShowOptions();
            }, 100);

          }}
        ></span>
      </div>
  }

  sendShowOptions() {
    this.props.saveShowOptions( this.state.show_options );
  }

  windowResize() {
    let windowWidthSize = window.innerWidth;
    window.onresize = () => {
      windowWidthSize = window.innerWidth;
      this.setState({ windowWidthSize });
    }
    this.setState({ windowWidthSize });
  }

  render() {
    const { items, windowWidthSize } = this.state;
    let wrapperStyle = {};
    let navigationText = [
      `<span class="dashicons ${this.props.options.iconOptionLeft}"></span>`,
      `<span class="dashicons ${this.props.options.iconOptionRight}"></span>`
    ];

    if(this.props.options.displayType == 'grid' && windowWidthSize > 750) {
      wrapperStyle = {
        gridTemplateColumns: `repeat(${this.props.options.product_columns}, 1fr)` ,
        gridColumnGap: `${this.props.options.product_columns_gap}px`,
        display: 'grid'
      }
    }

    else if  ( this.props.options.displayType == 'grid' && windowWidthSize < 600 && windowWidthSize > 319) {
      wrapperStyle = {
        gridTemplateColumns: `repeat(1, 1fr)` ,
        display: 'grid'
      }
    }

    else {
      wrapperStyle = {
        display: 'block'
      }
    }

    return (
      <Fragment>
        {this.props.options.displayType == 'slider' ? <div className={`${alias}PostItems-wrapper ${alias}PostItems-wrapper-slider`}>
          {this.state.items.length>0 ? <OwlCarousel2
                options={
                  {
                  margin: 20,
                  items: 1,
                  nav: true,
                  autoplay: false,
                  dotsEach: true,
                  navText: navigationText
                  }
                }
              >
                { this.buildPostsForSlider() }
              </OwlCarousel2> : ""}</div> : !this.props.options.show_carousel ? <Fragment>
          <div
            style={wrapperStyle}
            className={`${alias}PostItems-wrapper`}
          >
            { this.buildPosts('items') }
          </div>
          { this.state.items.length>0 ? this.pagination() : "" }
          </Fragment> : <div
            className={`${alias}PostItems-wrapper show-type-${this.props.options.displayType}`}
            >
              {this.state.items.length>0 ? <OwlCarousel2
                  options={
                    {
                    margin: this.props.options.carousel_gap,
                    items: this.props.options.displayType == 'grid' ? this.props.options.number_of_items : 1,
                    nav: true,
                    autoplay: false,
                    dotsEach: true,
                    navText: navigationText,
                    responsive: this.props.where == "frontend" ? {
                        0:{
                            items:1
                        },
                        600:{
                            items:1
                        },
                        1000: {
                            items: this.props.options.displayType == 'grid' ? this.props.options.number_of_items : 1
                        }
                      } : {}
                    }
                  }
                >
                {this.buildPosts('carouselItems')}
              </OwlCarousel2>:""}
            </div>
       }

      <style dangerouslySetInnerHTML={{__html: `
        .${alias}PostItems-wrapper .owl-carousel .owl-nav [class*='owl-'] {
          color: ${this.props.options.icon_text_color};
          background-color: ${this.props.options.icon_background_color};
        }

        .${alias}PostItems-wrapper .owl-carousel .owl-nav [class*='owl-']:hover {
          background: ${this.props.options.icon_active_color};
          color: ${this.props.options.icon_text_color_hover};
          text-decoration: none;
        }

        .${alias}PostItems-wrapper .owl-carousel .owl-dots .owl-dot.active span,
        .${alias}PostItems-wrapper .owl-carousel .owl-dots .owl-dot:hover span {
            background: #ffffff !important;
            border: 2px solid ${this.props.options.icon_text_color};
        }

        .${alias}PostItems-wrapper .owl-carousel .owl-dots .owl-dot span {
          border: 2px solid ${this.props.options.icon_background_color};
        }

        .${alias}wrapper .${alias}PostItems-wrapper .${alias}item .${alias}content .${alias}category:hover {
          color: ${this.props.options.category_text_color_hover} !important;
          background: ${this.props.options.category_active_color} !important;
        }
        .${alias}PostItems-pagination a:hover {
          background: ${this.props.options.paginate_active_color} !important;
        }

      `}}

      />
      </Fragment>

    );
  }
}

export { PostBerg_PostItems };



// WEBPACK FOOTER //
// ./src/js/PostItems.js